import grey from "@mui/material/colors/grey";
import createTheme from "@mui/material/styles/createTheme";

export const noraWebTheme = createTheme({
  palette: {
    background: {
      paper : grey[500],
      bgcolor : grey[500],
    },  
  },
});